var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, Lifecycle, scoped } from 'tsyringe';
import { Identity, IdentityInjectionToken } from './identity/Identity';
import { DestroySignal } from './DestroySignal';
import { LoggerFactory } from './utils/LoggerFactory';
import { Persistence } from '@/Persistence';
export const NAMESPACES = {
    ENCRYPTION_KEYS: 'EncryptionKeys',
    LATEST_ENCRYPTION_KEY_IDS: 'LatestEncryptionKeyIds'
};
let PersistenceManager = class PersistenceManager {
    persistence;
    identity;
    loggerFactory;
    /* eslint-disable indent */
    constructor(identity, destroySignal, loggerFactory) {
        this.identity = identity;
        this.loggerFactory = loggerFactory;
        destroySignal.onDestroy.listen(() => {
            if (this.persistence !== undefined) {
                return this.persistence.close();
            }
        });
    }
    async ensureInitialized() {
        this.persistence ??= await Persistence.createInstance({
            loggerFactory: this.loggerFactory,
            ownerId: await this.identity.getUserId(),
            namespaces: Object.values(NAMESPACES),
            migrationsUrl: new URL(/* webpackIgnore: true */ './encryption/migrations', import.meta.url),
        });
    }
    async getPersistence(namespace) {
        await this.ensureInitialized();
        return {
            get: (key) => {
                return this.persistence.get(key, namespace);
            },
            set: (key, value) => {
                return this.persistence.set(key, value, namespace);
            }
        };
    }
};
PersistenceManager = __decorate([
    scoped(Lifecycle.ContainerScoped),
    __param(0, inject(IdentityInjectionToken)),
    __metadata("design:paramtypes", [Identity,
        DestroySignal,
        LoggerFactory])
], PersistenceManager);
export { PersistenceManager };
//# sourceMappingURL=PersistenceManager.js.map